export const en = {
    'many-linked-camps-count': '{count} campaigns',
    'one-linked-camps': '{count} campaign',
    'some-linked-camps': '{count} campaigns',
    'zero-linked-camps': 'no linked campaigns'
};
